import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { CookieConsent, getStoredConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { HowItWorks } from './pages/HowItWorks';
import { GettingStarted } from './pages/GettingStarted';
import { Why } from './pages/Why';
import { Contact } from './pages/Contact';
import { PricingPage } from './pages/PricingPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { RobotsTxt } from './pages/RobotsTxt';
import { SitemapXml } from './pages/SitemapXml';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { TfpLandscapingPage } from './pages/CaseStudies/TfpLandscapingPage';
import { FinishCoatPaintingPage } from './pages/CaseStudies/FinishCoatPaintingPage';
import { GmailSignatureGeneratorPage } from './pages/tools/GmailSignatureGeneratorPage';
import { BlogPage } from './pages/BlogPage';
import { HowToChooseMarketingAgency } from './pages/blog/HowToChooseMarketingAgency';
import { WhyResponseTimeMakesOrBreaksYourYelpAds } from './pages/blog/WhyResponseTimeMakesOrBreaksYourYelpAds';
import { FasterYelpRepliesMoreLandscapingEstimates } from './pages/blog/FasterYelpRepliesMoreLandscapingEstimates';
import { AiReceptionistVsHumanReceptionistCost } from './pages/blog/AiReceptionistVsHumanReceptionistCost';
import { MissedCallTextBack } from './pages/blog/MissedCallTextBack';
function SiteLayout() {
  return <div className="flex min-h-screen flex-col bg-[#0a0a0a] font-sans text-neutral-100" data-id="element-0" data-mp="3dkus3sf1mymh">
      <Nav data-id="element-1" data-mp="3dii716dzo857" />
      {/* 2026-09-08 (compliance, Kevin): this noscript block is the raw HTML
          every non-JS crawler reads, so it is the highest-risk copy on the
          site. It listed a service link labelled "Reputation Management -
          Automated Reviews, Trust Building". Yelp flagged Viridia for review
          solicitation; that entry is removed. The remaining links point at
          routes that still resolve. Do not add review copy here. */}
      <noscript data-id="element-2" data-mp="d45uo6rhyho5">
        <div style={{
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }} data-id="element-3" data-mp="d2l7x3bfc30u">
          <h1 data-id="element-4" data-mp="3gklag2y7ng72">
            Viridia Analytics - Phoenix Marketing Agency for Local Service
            Businesses
          </h1>
          <p data-id="element-5" data-mp="3bnuv5hu8comp">
            We help local service businesses stop missing leads, respond
            instantly, and book more jobs. Real systems, real results from real
            Phoenix-area clients.
          </p>
          <h2 data-id="element-6" data-mp="3lj6bg4lae3wk">Our Services</h2>
          <ul data-id="element-7" data-mp="2xuwqt5zt7m70">
            <li data-id="element-8" data-mp="2xud8vpa5sxsz">
              <a href="/ai-lead-conversion" data-id="element-9" data-mp="2xtv76d4q9rdo">
                AI Lead Conversion - Follow-Up, AI Receptionist, Lead Nurturing
              </a>
            </li>
            <li data-id="element-10" data-mp="18drky0d87nfx">
              <a href="/custom-automations" data-id="element-11" data-mp="18d9c849dngr4">
                Custom Automations - Tailored Workflows, API Integrations
              </a>
            </li>
            <li data-id="element-12" data-mp="1d5su3df3ky1q">
              <a href="/crm-business-tools" data-id="element-13" data-mp="1d6aywyftskl9">
                CRM &amp; Business Tools - Centralized Hub, Invoicing, Pipeline
              </a>
            </li>
            <li data-id="element-14" data-mp="13fgabnf3x8wn">
              <a href="/ad-campaigns" data-id="element-15" data-mp="13ey35vqwpa9y">
                Ad Campaign Management - Google Ads, Meta Ads, and local lead
                platforms
              </a>
            </li>
            <li data-id="element-16" data-mp="1w211amro7izo">
              <a href="/web-design-seo" data-id="element-17" data-mp="1w2kig19hy3cn">Web Design &amp; Local SEO</a>
            </li>
          </ul>
          <h2 data-id="element-18" data-mp="1i3b4774upjbb">Contact Us</h2>
          <p data-id="element-19" data-mp="1m560tybu78ir">
            Phone: <a href="tel:6233000708" data-id="element-20" data-mp="1m4mt1afwi0ig">(623) 300-0708</a>
          </p>
          <p data-id="element-21" data-mp="1m70pnnq8bks4">
            Email:{' '}
            <a href="mailto:info@viridiaanalytics.com" data-id="element-22" data-mp="6o5w1nlyaskb">
              info@viridiaanalytics.com
            </a>
          </p>
          <p data-id="element-23" data-mp="arkfypd0ft31">Location: Phoenix, AZ - Serving Local Businesses</p>
          <h2 data-id="element-24" data-mp="qxnifbnxjwqb">Quick Links</h2>
          <ul data-id="element-25" data-mp="qxxad4sjcdyn">
            <li data-id="element-26" data-mp="qygkhzby1y24">
              <a href="/about" data-id="element-27" data-mp="qyyqvosblsnr">About Us</a>
            </li>
            <li data-id="element-28" data-mp="m5ng5cke0rqk">
              <a href="/case-studies" data-id="element-29" data-mp="m549wt43nrsd">Case Studies</a>
            </li>
            <li data-id="element-30" data-mp="h8drhz4tok3s">
              <a href="/pricing" data-id="element-31" data-mp="h7vmoe43gxk9">Pricing</a>
            </li>
            <li data-id="element-32" data-mp="c8rf1rwtj7w1">
              <a href="/contact" data-id="element-33" data-mp="c9alabd3w7u8">Book a Free Strategy Call</a>
            </li>
            <li data-id="element-34" data-mp="19wjfcur6ap7u">
              <a href="/privacy" data-id="element-35" data-mp="19uyj90p7my7v">Privacy Policy</a>
            </li>
            <li data-id="element-36" data-mp="14x6gtcqxvtpf">
              <a href="/terms" data-id="element-37" data-mp="14wetsqber4ar">Terms of Service</a>
            </li>
          </ul>
        </div>
      </noscript>
      <main role="main" className="flex-grow" data-id="element-38" data-mp="zwsjaomys25n">
        <Routes data-id="element-39" data-mp="zzwrry7gpk24">
          <Route path="/" element={<Home data-id="element-41" data-mp="vx07m329xfw2" />} data-id="element-40" data-mp="vw8jteex4mgc" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-43" data-mp="vyl0zpcuqssc" />} data-id="element-42" data-mp="vvgqybcph2tr" />
          <Route path="/getting-started" element={<GettingStarted data-id="element-45" data-mp="3kpm9qk3gplz1" />} data-id="element-44" data-mp="3koklfdxfr2zd" />
          <Route path="/why" element={<Why data-id="element-47" data-mp="3gly1s0ax4od9" />} data-id="element-46" data-mp="3klq25pq5ro7j" />
          <Route path="/pricing" element={<PricingPage data-id="element-49" data-mp="3gl648jxrggkc" />} data-id="element-48" data-mp="3glegc9m27huh" />
          <Route path="/contact" element={<Contact data-id="element-51" data-mp="1w583f5lxr2w8" />} data-id="element-50" data-mp="1w4f58t11llpp" />
          <Route path="/services" element={<Navigate to="/how-it-works" replace data-id="element-53" data-mp="1w2lx19as6tfl" />} data-id="element-52" data-mp="1w5zzehjg32n1" />
          <Route path="/ai-lead-conversion" element={<Navigate to="/how-it-works" replace data-id="element-55" data-mp="203nubkl50vex" />} data-id="element-54" data-mp="206tkl35i63c8" />
          <Route path="/automations" element={<Navigate to="/how-it-works" replace data-id="element-57" data-mp="2530j4avkkck5" />} data-id="element-56" data-mp="25422r3qni7dh" />
          <Route path="/custom-automations" element={<Navigate to="/how-it-works" replace data-id="element-59" data-mp="29xwla3uisgaz" />} data-id="element-58" data-mp="29w3gyv7dq865" />
          <Route path="/crm-business-tools" element={<Navigate to="/how-it-works" replace data-id="element-61" data-mp="2eumxgg37err4" />} data-id="element-60" data-mp="2evppwsg6d295" />
          <Route path="/reputation-management" element={<Navigate to="/how-it-works" replace data-id="element-63" data-mp="2js6hjwml1yqz" />} data-id="element-62" data-mp="2jt83iw5505nh" />
          <Route path="/ad-campaigns" element={<Navigate to="/how-it-works" replace data-id="element-65" data-mp="2nwe5hrl7vao5" />} data-id="element-64" data-mp="2nvcshhkn4e3s" />
          <Route path="/google-business-profile-setup" element={<Navigate to="/how-it-works" replace data-id="element-67" data-mp="thlbty3w8tyu" />} data-id="element-66" data-mp="2sv7izk0i71ob" />
          <Route path="/web-design-seo" element={<Navigate to="/pricing" replace data-id="element-69" data-mp="ygoito3fpa9g" />} data-id="element-68" data-mp="tj4svqxdj91o" />
          <Route path="/about" element={<Navigate to="/why" replace data-id="element-71" data-mp="yir6w2l10tbj" />} data-id="element-70" data-mp="yhg3i3vhtnky" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="element-73" data-mp="21s3wz2qf0om3" />} data-id="element-72" data-mp="21r2dqaz8wvta" />
          <Route path="/case-studies/tfp-landscaping" element={<TfpLandscapingPage data-id="element-75" data-mp="1wtsoavbuwk5g" />} data-id="element-74" data-mp="1wsh9m0gvhrzk" />
          <Route path="/case-studies/finish-coat-painting" element={<FinishCoatPaintingPage data-id="element-77" data-mp="2atjxmirfhcd4" />} data-id="element-76" data-mp="1wuu1b5cfngpt" />
          <Route path="/blog" element={<BlogPage data-id="element-79" data-mp="25se4wkxrpp3l" />} data-id="element-78" data-mp="25snwue2di6bx" />
          <Route path="/blog/how-to-choose-marketing-agency" element={<HowToChooseMarketingAgency data-id="element-81" data-mp="2kovdj4ekopmg" />} data-id="element-80" data-mp="25runr6fxz4qm" />
          <Route path="/blog/why-response-time-makes-or-breaks-your-yelp-ads" element={<WhyResponseTimeMakesOrBreaksYourYelpAds data-id="element-83" data-mp="2tii4mh7u54pb" />} data-id="element-82" data-mp="2frljtck5hrst" />
          <Route path="/blog/faster-yelp-replies-more-landscaping-estimates" element={<FasterYelpRepliesMoreLandscapingEstimates data-id="element-85" data-mp="2pj9cfgsg1evv" />} data-id="element-84" data-mp="2tkujumm7l0yo" />
          <Route path="/blog/ai-receptionist-vs-human-receptionist-cost" element={<AiReceptionistVsHumanReceptionistCost data-id="element-87" data-mp="2yj5v91s5jjj0" />} data-id="element-86" data-mp="33hpl3d9v9fgn" />
          <Route path="/blog/missed-call-text-back-phoenix-home-services" element={<MissedCallTextBack data-id="element-89" data-mp="3n2fyzmqln3s6" />} data-id="element-88" data-mp="3i3wezrvkg22g" />
          <Route path="/f/why-response-time-makes-or-breaks-your-yelp-ads" element={<Navigate to="/blog/why-response-time-makes-or-breaks-your-yelp-ads" replace data-id="element-91" data-mp="385778rxdvxzx" />} data-id="element-90" data-mp="3n27mhvye20hi" />
          <Route path="/f/faster-yelp-replies-more-landscaping-estimates" element={<Navigate to="/blog/faster-yelp-replies-more-landscaping-estimates" replace data-id="element-93" data-mp="344n8xl12qoc7" />} data-id="element-92" data-mp="2zcvidahx4im2" />
          <Route path="/tools/gmail-signature-generator" element={<GmailSignatureGeneratorPage data-id="element-95" data-mp="2ubpkyzdbc767" />} data-id="element-94" data-mp="2udsl4c86jgon" />
          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-97" data-mp="2ggds6xipwqrx" />} data-id="element-96" data-mp="2gfc7007zmnwh" />
          <Route path="/terms" element={<TermsOfServicePage data-id="element-99" data-mp="2ketaio3utaz0" />} data-id="element-98" data-mp="2kfmkdxy40gld" />
        </Routes>
      </main>
      <Footer data-id="element-100" data-mp="30v3tajqkgnxu" />
      <CookieConsent data-id="element-101" data-mp="30vwznjlm5bfg" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Cookie-consent gate (added 2026-08-04): a declined choice stored from
    // a previous visit skips these scripts entirely. An accepted or
    // not-yet-decided visitor still gets them by default -- CookieConsent's
    // banner still shows either way so the choice is disclosed, matching
    // the site's own Privacy Policy (which already names Meta/Google as
    // third parties). A decision made THIS session can't un-fire a pixel
    // that already loaded before the banner was clicked, but it's honored
    // on every subsequent page load for as long as it's stored.
    if (getStoredConsent() === 'declined') {
      return;
    }
    // Google Analytics (gtag.js)
    const GA_MEASUREMENT_ID = 'G-C4JZKB2BFQ';
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gtagScript);
    const gtagInit = document.createElement('script');
    gtagInit.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(gtagInit);
    // Meta Pixel
    const fbScript = document.createElement('script');
    fbScript.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '970566142171718');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
    const fbNoscript = document.createElement('noscript');
    const fbImg = document.createElement('img');
    fbImg.height = 1;
    fbImg.width = 1;
    fbImg.style.display = 'none';
    fbImg.src = 'https://www.facebook.com/tr?id=970566142171718&ev=PageView&noscript=1';
    fbNoscript.appendChild(fbImg);
    document.body.appendChild(fbNoscript);
    // GHL Chat Widget
    const chatDiv = document.createElement('div');
    chatDiv.setAttribute('data-chat-widget', '');
    chatDiv.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    chatDiv.setAttribute('data-location-id', 'JLycxFbUVQFY3z4zPpCS');
    document.body.appendChild(chatDiv);
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    document.body.appendChild(script);
    return () => {
      if (gtagScript.parentNode) gtagScript.parentNode.removeChild(gtagScript);
      if (gtagInit.parentNode) gtagInit.parentNode.removeChild(gtagInit);
      if (fbScript.parentNode) fbScript.parentNode.removeChild(fbScript);
      if (fbNoscript.parentNode) fbNoscript.parentNode.removeChild(fbNoscript);
      if (chatDiv.parentNode) chatDiv.parentNode.removeChild(chatDiv);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  return <BrowserRouter data-id="element-102" data-mp="3d2r1tyrhlwni">
      <ScrollToTop data-id="element-103" data-mp="389xx3aw0qobf" />
      <Routes data-id="element-104" data-mp="389ed7omt5pur">
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-106" data-mp="388muheeb7mlw" />} data-id="element-105" data-mp="388v6z56ispwk" />
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-108" data-mp="347jbwk4vncgz" />} data-id="element-107" data-mp="348cd75l2h9rq" />
        <Route path="/*" element={<SiteLayout data-id="element-110" data-mp="345yiwyy7o1l8" />} data-id="element-109" data-mp="348ufojybok83" />
      </Routes>
    </BrowserRouter>;
}